<template>
    <div 
        class="d-flex align-items-center justify-content-center"
        style="height: 100vh;"
    >
        <template v-if="passwordUpdated">
            <div
                class="card border-light" 
                style="width: 18rem; margin: 40px auto 0;"
            >
                <div class="card-body text-center">
                    <b-icon icon="check-circle-fill" variant="success" font-scale="7.5" class="mb-2"></b-icon>
                    <h5 class="card-title">{{ $t("done") }}</h5>
                    <p class="card-text">
                        {{ $t('password-updated') }}
                    </p>
                </div>
            </div>
        </template>
        <template v-else>
            <div
                v-if="!passwordChecked"
                class="card border-light" 
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <h5 class="card-title">{{ $t("change-password") }}</h5>
                    <p class="card-text">
                        {{ $t("your-current-password") }}
                    </p>
                    <PasswordInput
                        id="current-password"
                        v-model="currentPassword"
                        :label="$t('password')"
                        sr-only
                        :placeholder="$t('password')"
                        autocomplete="current-password"
                        :error-message="incorrectPassword ? $t('wrong-password') : ''"
                        class="mb-0 text-left"
                        @enter="passwordAction('check')"
                    />
                    <div>
                        <button
                        class="btn btn-primary mt-2"
                        @click="passwordAction('check')"
                        >
                            {{$t('confirm')}}
                        </button>
                    </div>
                    
                </div>
            </div>
            <div
                v-if="passwordChecked"
                class="card border-light" 
                style="width: 18rem;"
            >
                <div class="card-body text-center">
                    <h5 class="card-title">{{ $t("new-password") }}</h5>
                    <p class="card-text">
                        {{ $t("new-password") }}
                    </p>
                    <PasswordInput
                        id="new-password"
                        v-model="newPassword"
                        :label="$t('new-password')"
                        sr-only
                        :placeholder="$t('new-password')"
                        autocomplete="new-password"
                        :error-message="passwordTooShort ? $t('password-min-length') : ''"
                        show-strength
                        class="mb-2 text-left"
                    />
                    <PasswordInput
                        id="confirm-new-password"
                        v-model="confirmNewPassword"
                        :label="$t('confirm-new-password')"
                        sr-only
                        :placeholder="$t('confirm-new-password')"
                        autocomplete="new-password"
                        :error-message="passwordMismatch ? $t('password-and-confirm-not-equal') : ''"
                        class="mb-0 text-left"
                    />
                    <button
                        class="btn btn-primary mt-2"
                        @click="passwordAction('update')"
                        :disabled="newPassword !== confirmNewPassword || newPassword.length < 6"
                    >
                        {{$t('update')}}
                    </button>
                </div>
            </div>
        </template>
       
        

    </div>
</template>
<script>
export default {
	components: {
     
	},
    data() {
        return {
            incorrectPassword: false,
            passwordChecked: false,
            passwordUpdated: false,
            currentPassword: null,
            newPassword: '',
            confirmNewPassword: ''
        }
    },
    computed: {
        passwordTooShort() {
            return this.newPassword.length > 0 && this.newPassword.length < 6;
        },
        passwordMismatch() {
            return this.newPassword.length > 0 && this.confirmNewPassword.length > 0 && this.newPassword !== this.confirmNewPassword;
        }
    },
    methods: {
        passwordAction(action) {
			this.$cfetch(`${this.$settings.APIBaseURL}/users/changepassword`, {
				method: "post",
				data: {
                    curpassword: this.currentPassword,
                    action: action,
                    pass1: this.newPassword,
                    pass2: this.confirmNewPassword
                },
			}).then((res) => {
                if (res.status === "SUCCESS") {
                    if(res.checked === true) {
                        this.passwordChecked = true;
                        this.incorrectPassword = false;
                    }
                    if(res.updated === true) {
                        this.passwordChecked = true;
                        this.incorrectPassword = false;
                        this.passwordUpdated = true;
                    }
                } else {
                    if(res.errorType === "ERROR_INCORRECT_PASSWORD") this.incorrectPassword = true
                }
            })
            .catch((error) => {
                this.$log.error.call(this, error);
            });
		},
    }
} 
</script>